// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fZ","gallery__header":"c-q_ga","gallery__thumbs":"c-q_gb"};